import React from "react";
import { useQuery } from "react-query";
import { Form } from "antd";
import srv from "../../../../../services";
import { Uploader, FileInput } from "../../../../_common";
import { Wrapper, Label, Spin } from "./AppealFiles.styled";

interface Props {
  topicId?: number;
}

export default function AppealFiles({ topicId }: Props) {
  const { data, isLoading } = useQuery<Models.FileTypes>(
    ["fileTypes", topicId],
    () => srv.getFileTypes(topicId),
    { enabled: !!topicId }
  );
  return (
    <Wrapper>
      <Label>Прикрепление документов</Label>

      {isLoading ? (
        <Spin />
      ) : (
        <>
          {!!data?.fileTypes?.length && (
            <>
              {data.fileTypes.map((fileType) => (
                <Form.Item
                  key={`fileType_${fileType.id}`}
                  name={`fileType_${fileType.id}`}
                  rules={[{ required: fileType.required }]}
                >
                  <FileInput
                    key={fileType.id}
                    category={fileType.name}
                    required={fileType.required}
                  />
                </Form.Item>
              ))}
            </>
          )}

          {!data?.limited && (
            <Form.Item name="files">
              <Uploader />
            </Form.Item>
          )}
        </>
      )}
    </Wrapper>
  );
}
